import { path } from 'ramda';

const getPersonInwork = path(['person', 'inwork']);
const getProjectInwork = path(['project', 'inwork']);

export const getNewNotifications = (oldState, newState) => {
    const oldPerson = getPersonInwork(oldState);
    const oldProject = getProjectInwork(oldState);

    const newPerson = getPersonInwork(newState);
    const newProject = getProjectInwork(newState);

    return {
        person: (oldPerson !== undefined) && (newPerson > oldPerson) ? newPerson - oldPerson : null,
        project: (oldProject !== undefined) && (newProject > oldProject) ? newProject - oldProject : null
    }
}
